import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { FaInstagram, FaLinkedin, FaYoutube, FaUserCircle } from "react-icons/fa"; // Import icons

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      await emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY);
      setSuccessMessage("Your message has been sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Email sending failed:", error);
      setErrorMessage("Failed to send your message. Please try again later.");
    }
  };

  return (
    <div id="contact-us" className="bg-[#EBE9E7] py-12 px-6 sm:px-12 lg:px-20">
      <div className="flex flex-col lg:flex-row justify-between gap-6">
        {/* Left Section - Contact Details */}
        <div className="lg:w-1/2 mb-8 lg:mb-0">
          <h3 className="text-xl sm:text-2xl font-[20px] mb-4 font-bicyclete text-about-me-orange">
            Contact Us
          </h3>
          <h2 className="text-xl sm:text-lg font-semibold text-gray-800 mb-2">
            Get in touch today to schedule your Reiki appointment
          </h2>
          <hr className="border-t border-gray-300 mb-6" />
          <div>
            <h4 className="text-xl font-medium text-gray-800 mb-2">Location</h4>
            <p className="text-gray-700 mb-1">
              <strong className="text-amber-600">Burlington, ON:</strong> Thursday, Friday
            </p>
          </div>
          {/* Social Media Icons */}
          <div className="flex mt-6 space-x-4">
            <a href="https://www.instagram.com/radiantlighthealing2024" className="text-about-me-orange text-2xl" target="_blank" rel="noopener noreferrer">
              <FaInstagram aria-label="Instagram" role="img" />
            </a>
            <a href="https://www.linkedin.com/in/ankita-singh-16931091/" className="text-about-me-orange text-2xl" target="_blank" rel="noopener noreferrer">
              <FaLinkedin aria-label="LinkedIn" role="img" />
            </a>
            <a href="https://www.youtube.com/channel/UCyE_Lj-F1uaJr55f7VEYGCw" className="text-about-me-orange text-2xl" target="_blank" rel="noopener noreferrer">
              <FaYoutube aria-label="YouTube" role="img" />
            </a>
            <a href="https://reiki.ca/practitioners-teachers/practitioner-teacher-directory/#/action/Listing/value/34204/searchID/593515/cid/1269/id/2501/Ankita-Singh" className="text-about-me-orange text-2xl" target="_blank" rel="noopener noreferrer" title="Canadian Reiki Association Profile">
              <FaUserCircle aria-label="Canadian Reiki Association profile" role="img" />
            </a>
          </div>
        </div>

        {/* Right Section - Contact Form */}
        <div className="lg:w-1/2 bg-white shadow-lg rounded-lg p-6">
          <h3 className="text-about-me-orange text-lg sm:text-xl font-bicyclete text-center mb-4">
            Contact Form
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label htmlFor="name" className="block text-gray-700 font-medium">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring focus:ring-amber-600"
              />
            </div>
            {/* Email */}
            <div>
              <label
                htmlFor="email"
                className="block text-gray-700 font-medium"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring focus:ring-amber-600"
              />
            </div>
            {/* Message */}
            <div>
              <label
                htmlFor="message"
                className="block text-gray-700 font-medium"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring focus:ring-amber-600"
                rows="4"
              ></textarea>
            </div>
            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-about-me-orange text-white py-3 rounded-lg font-medium hover:bg-amber-700 transition duration-200"
            >
              Send Message
            </button>
          </form>
          {/* Success or Error Messages */}
          {successMessage && (
            <p className="text-green-600 text-center mt-4">{successMessage}</p>
          )}
          {errorMessage && (
            <p className="text-red-600 text-center mt-4">{errorMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
